<template>
  <div>
    <h1>Inicio</h1>
  </div>
</template>

<script>
export default {
  name: 'Inicio'
}
</script>
